import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import TaskManagement_Staff_001 from './img/TaskManagement_Staff_001.png'
import TaskManagement_Staff_002 from './img/TaskManagement_Staff_001.png'
import TaskManagement_Staff_003 from './img/TaskManagement_Staff_001.png'
import TaskManagement_Staff_004 from './img/TaskManagement_Staff_001.png'

export default class StaffTaskManagement extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">业务员处理整个任务中的单个步骤</div>
        <div className="main-window-content">业务员使用任务管理，处理从管理员处收到的具体任务的算法数据修改工作</div>
        <div className="main-window-content">业务人员点击确认提交处理按钮，在弹出确认框中点选确认，则文档提交，不能修改，请仔细检查文档后提交</div>
        <img src={TaskManagement_Staff_001} className="main-window-img"></img>
        <img src={TaskManagement_Staff_002} className="main-window-img"></img>
        <img src={TaskManagement_Staff_003} className="main-window-img"></img>
        <img src={TaskManagement_Staff_004} className="main-window-img"></img>
      </div>
    )
  }
}
